import React from "react";
import {
  firstValue,
  getConfigValue,
  getDocumentAmount,
  getDocumentDate,
  getDocumentNumber,
  getDocumentStatus,
  getPartyName,
  money,
  text,
} from "./documentHelpers";

const DocumentSummary = ({ row = {}, config = {} }) => {
  const validValue = getConfigValue(config, "validValue", row);
  const status = getDocumentStatus(row, config);

  return (
    <div className="document-summary-grid">
      <article className="document-side-card">
        <h3>{config.singular || "Document"} Details</h3>
        <dl>
          <div><dt>Number</dt><dd>{getDocumentNumber(row, config)}</dd></div>
          <div><dt>Date</dt><dd>{getDocumentDate(row, config)}</dd></div>
          <div><dt>{config.validLabel || "Reference"}</dt><dd>{text(validValue || firstValue(row, ["reference", "orderNumber"], ""))}</dd></div>
          <div><dt>Status</dt><dd>{status.label}</dd></div>
        </dl>
      </article>

      <article className="document-side-card">
        <h3>{config.partyLabel || "Customer"} Details</h3>
        <strong className="document-party-name">{getPartyName(row, config)}</strong>
        <p>{text(firstValue(row, ["billingAddress", "deliveryAddress", "deliverTo", "address"], ""))}</p>
        <dl>
          <div><dt>Phone</dt><dd>{text(firstValue(row, ["phone", "mobile", "billPhone"], ""))}</dd></div>
          <div><dt>Email</dt><dd>{text(firstValue(row, ["email", "customerEmail", "vendorEmail"], ""))}</dd></div>
        </dl>
      </article>

      <article className="document-side-card">
        <h3>Summary</h3>
        <dl>
          <div><dt>Reference</dt><dd>{text(firstValue(row, ["reference", "orderNumber", "invoice"], ""))}</dd></div>
          <div><dt>Amount</dt><dd>{money(getDocumentAmount(row, config))}</dd></div>
          <div><dt>Payment Mode</dt><dd>{text(firstValue(row, ["paymentMode", "paidThrough"], ""))}</dd></div>
        </dl>
      </article>
    </div>
  );
};

export default DocumentSummary;
